module.exports = __webpack_public_path__ + "static/media/icon_localization.7e2b37f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_localization.svg
// module id = 623
// module chunks = 0